/* B2B / B2C Hybrid Storefront Core JavaScript */

(function() {
  'use strict';

  const STORAGE_KEY = 'shopping_mode';
  const COOKIE_NAME = 'shopping_mode';
  const DEFAULT_MODE = 'retail';
  const MODE_RETAIL = 'retail';
  const MODE_BUSINESS = 'business';

  // Helper: Read Cookie
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  // Helper: Write Cookie (Permanent, 365 Days)
  function setCookie(name, value) {
    const d = new Date();
    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax`;
  }

  // Get active mode from localStorage or Cookie
  function getActiveMode() {
    let mode = localStorage.getItem(STORAGE_KEY);
    if (!mode) {
      mode = getCookie(COOKIE_NAME);
    }
    return mode || DEFAULT_MODE;
  }

  // Set active mode in localStorage and Cookie
  function setActiveMode(mode) {
    if (mode !== MODE_RETAIL && mode !== MODE_BUSINESS) mode = DEFAULT_MODE;
    localStorage.setItem(STORAGE_KEY, mode);
    setCookie(COOKIE_NAME, mode);
    
    // Apply body and html classes with safety check
    if (document.body) {
      document.body.classList.remove('shopping-mode-retail', 'shopping-mode-business', 'mode-retail', 'mode-business');
      document.body.classList.add(`shopping-mode-${mode}`, `mode-${mode}`);
    }
    if (document.documentElement) {
      if (mode === MODE_BUSINESS) {
        document.documentElement.classList.add('b2b-active');
      } else {
        document.documentElement.classList.remove('b2b-active');
      }
    }

    // Toggle Bundler app widget visibility
    toggleBundlerAppVisibility(mode);

    // Update toggles on page
    updateToggleControls(mode);

    // Dispatch event
    window.dispatchEvent(new CustomEvent('b2bModeChanged', { detail: { mode: mode } }));
  }

  // Toggle Bundler App Widgets (Only visible in B2B Mode)
  function toggleBundlerAppVisibility(currentMode) {
    const mode = currentMode || getActiveMode();
    const isBusiness = (mode === MODE_BUSINESS);
    
    const bundlerEls = document.querySelectorAll(
      '[class*="bundler"], [id*="bundler"], .bundler-target-element, .bk-summary, [data-bundler-container], iframe[src*="bundler"]'
    );
    
    bundlerEls.forEach(function(el) {
      if (isBusiness) {
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('opacity');
        el.style.removeProperty('height');
      } else {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('height', '0', 'important');
      }
    });
  }

  // Relocate Bundler App Widget into #b2b-bundler-slot (In-between specs grid & bulk contact box)
  function relocateBundlerWidget() {
    const slot = document.getElementById('b2b-bundler-slot');
    if (!slot) return;

    // Layer 1: Scan by class/id/attributes
    const candidates = document.querySelectorAll(
      '[class*="bundler"], [id*="bundler"], [class*="bk-"], .bundler-target-element, .bk-summary, .bk-bundle, [data-bundler-container], .bundler-container, .bundler-app, bundler-component, bundler-app'
    );

    candidates.forEach(function(el) {
      if (el && el !== slot && !slot.contains(el) && !el.contains(slot) && el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE') {
        const parent = el.parentElement;
        if (parent && !parent.classList.contains('b2b-bundler-slot') && parent.id !== 'b2b-bundler-slot') {
          slot.appendChild(el);
        }
      }
    });

    // Layer 2: Text content scan for "BUY IN BULK AND GET A DISCOUNT"
    const textElements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, div, p');
    textElements.forEach(function(el) {
      if (el && el.innerText && el.innerText.toUpperCase().includes('BUY IN BULK AND GET A DISCOUNT')) {
        let box = el;
        while (box.parentElement && box.parentElement.tagName !== 'BODY' && box.parentElement.tagName !== 'MAIN' && !box.parentElement.classList.contains('b2b-product-specs-container')) {
          if (box.parentElement.id === 'b2b-bundler-slot' || box.parentElement.classList.contains('b2b-bundler-slot')) break;
          box = box.parentElement;
        }
        if (box && box.id !== 'b2b-bundler-slot' && !box.classList.contains('b2b-bundler-slot') && !slot.contains(box)) {
          slot.appendChild(box);
        }
      }
    });
  }

  // Active continuous enforcement for dynamically injected Bundler App widgets & currency conversion
  setInterval(function() {
    relocateBundlerWidget();
    toggleBundlerAppVisibility();
    if (typeof convertAllStorefrontPrices === 'function') {
      convertAllStorefrontPrices();
    }
  }, 100);

  // Synchronize state of toggle controls on page
  function updateToggleControls(mode) {
    const containers = document.querySelectorAll('.b2b-toggle-container');
    containers.forEach(container => {
      const retailBtn = container.querySelector('.mode-retail');
      const businessBtn = container.querySelector('.mode-business');
      if (mode === MODE_RETAIL) {
        if (retailBtn) retailBtn.classList.add('active');
        if (businessBtn) businessBtn.classList.remove('active');
      } else {
        if (retailBtn) retailBtn.classList.remove('active');
        if (businessBtn) businessBtn.classList.add('active');
      }
    });

    // Update modal selections
    const modalCards = document.querySelectorAll('.b2b-modal-card');
    modalCards.forEach(card => {
      if (card.dataset.mode === mode) {
        card.classList.add('active');
      } else {
        card.classList.remove('active');
      }
    });
  }

  // Trigger Switch Mode with Premium Fullscreen Blur Overlay
  function switchMode(newMode) {
    const currentMode = getActiveMode();
    if (newMode === currentMode) return;

    // Show Overlay with safety check
    if (document.body) {
      document.body.classList.add('loading-mode-switch');
    }

    // Switch after overlay is shown (800ms to 1200ms transition time)
    setTimeout(function() {
      setActiveMode(newMode);
      
      // If we are on the homepage, refresh/redraw layout where needed
      if (window.dispatchEvent) {
        window.dispatchEvent(new Event('resize'));
      }
      
      // Hide Overlay with fade out
      setTimeout(function() {
        if (document.body) {
          document.body.classList.remove('loading-mode-switch');
        }
      }, 400);

    }, 1000);
  }

  // Initialize
  function init() {
    const mode = getActiveMode();
    
    // Apply immediate class to prevent layout shift with safety check
    if (document.body) {
      document.body.classList.add(`shopping-mode-${mode}`);
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        if (document.body) {
          document.body.classList.add(`shopping-mode-${mode}`);
        }
      });
    }
    
    // Setup Header Toggle Buttons
    document.addEventListener('click', function(e) {
      // Switch Toggle Button Click
      const toggleBtn = e.target.closest('.b2b-toggle-container');
      if (toggleBtn) {
        openExperienceModal();
        return;
      }

      // Close modal
      if (e.target.closest('.b2b-modal-close') || e.target.matches('#b2b-experience-modal')) {
        closeExperienceModal();
        return;
      }

      // Selection card in modal
      const modalCard = e.target.closest('.b2b-modal-card');
      if (modalCard) {
        const selectedMode = modalCard.dataset.mode;
        closeExperienceModal();
        switchMode(selectedMode);
        return;
      }

      // FAQ accordion
      const faqQuestion = e.target.closest('.b2b-faq-question');
      if (faqQuestion) {
        const item = faqQuestion.closest('.b2b-faq-item');
        item.classList.toggle('active');
        return;
      }
    });

    updateToggleControls(mode);

    // Initial page integrations
    setupProductPageIntegrations(mode);
    setupCartPageIntegrations(mode);
    setupDynamicCurrencyConverter();

    // Re-run setup on dynamic updates
    window.addEventListener('b2bModeChanged', function(e) {
      setupProductPageIntegrations(e.detail.mode);
      setupCartPageIntegrations(e.detail.mode);
    });
  }

  // Open the Selection Modal
  function openExperienceModal() {
    const modal = document.getElementById('b2b-experience-modal');
    if (modal) {
      const mode = getActiveMode();
      updateToggleControls(mode);
      modal.classList.add('active');
    }
  }

  // Close the Selection Modal
  function closeExperienceModal() {
    const modal = document.getElementById('b2b-experience-modal');
    if (modal) {
      modal.classList.remove('active');
    }
  }

  // ----------------------------------------
  // Product Page Tier Pricing & MOQ Calculations
  // ----------------------------------------
  function setupProductPageIntegrations(mode) {
    const productDataEl = document.querySelector('.b2b-product-data');
    if (!productDataEl) return;

    // Extract product details
    const retailPrice = parseFloat(productDataEl.dataset.retailPrice);
    const rawWholesale = productDataEl.dataset.wholesalePrice;
    
    // Default Wholesale price is 75% of Retail if not set
    const wholesalePrice = rawWholesale ? parseFloat(rawWholesale) : (retailPrice * 0.75);
    const moq = parseInt(productDataEl.dataset.moq || '5', 10);
    
    // Elements on product page
    const qtyInput = document.querySelector('input[name="quantity"]');
    const addToCartBtn = document.querySelector('[name="add"]');
    const addToCartText = addToCartBtn ? addToCartBtn.querySelector('span') : null;
    const form = qtyInput ? qtyInput.closest('form') : null;

    if (mode === MODE_BUSINESS) {
      // In business mode, enforce MOQ
      if (qtyInput) {
        const currentQty = parseInt(qtyInput.value, 10);
        if (currentQty < moq) {
          qtyInput.value = moq;
          qtyInput.min = moq;
        }
      }

      // Add dynamic calculation support
      if (qtyInput) {
        qtyInput.removeEventListener('input', updateProductPricingSummary);
        qtyInput.addEventListener('input', updateProductPricingSummary);
      }

      // If variant changes, update pricing summary
      const variantSelector = document.querySelector('.product-form__variants, select[name="id"]');
      if (variantSelector) {
        variantSelector.removeEventListener('change', handleVariantChange);
        variantSelector.addEventListener('change', handleVariantChange);
      }

      updateProductPricingSummary();
    } else {
      // In retail mode, restore defaults
      if (qtyInput) {
        qtyInput.min = 1;
      }
      const warningEl = document.querySelector('.b2b-moq-warning');
      if (warningEl) warningEl.classList.remove('active');
    }

    // Intercept form submit to validate MOQ
    if (form) {
      form.removeEventListener('submit', validateProductFormSubmit);
      form.addEventListener('submit', validateProductFormSubmit);
    }

    function handleVariantChange() {
      // Brief delay to let theme JS finish updating prices/variants
      setTimeout(function() {
        // Read new price
        const priceContainer = document.querySelector('[itemprop="price"], #ProductPrice-product-template-1');
        if (priceContainer) {
          // Re-evaluate base price
          const cleanText = priceContainer.innerText.replace(/[^0-9.]/g, '');
          const newRetailPrice = parseFloat(cleanText) * 100;
          if (!isNaN(newRetailPrice)) {
            productDataEl.dataset.retailPrice = newRetailPrice;
            updateProductPricingSummary();
          }
        }
      }, 100);
    }

    function updateProductPricingSummary() {
      if (!qtyInput) return;
      const qty = parseInt(qtyInput.value, 10) || moq;

      // Tier Discounts:
      // 1-10 Units: Base WP
      // 11-50 Units: 10% wholesale discount (WP * 0.9)
      // 51-100 Units: 20% wholesale discount (WP * 0.8)
      // 101+ Units: 30% wholesale discount (WP * 0.7)
      let activePrice = wholesalePrice;
      let tierIndex = 1;

      if (qty >= 11 && qty <= 50) {
        activePrice = wholesalePrice * 0.90;
        tierIndex = 2;
      } else if (qty >= 51 && qty <= 100) {
        activePrice = wholesalePrice * 0.80;
        tierIndex = 3;
      } else if (qty >= 101) {
        activePrice = wholesalePrice * 0.70;
        tierIndex = 4;
      }

      // Highlight tier in Table
      const rows = document.querySelectorAll('.b2b-tiers-table tbody tr');
      rows.forEach((row, idx) => {
        if (idx + 1 === tierIndex) {
          row.classList.add('highlighted');
        } else {
          row.classList.remove('highlighted');
        }
      });

      // Update unit pricing display
      const unitPriceVal = document.querySelector('.b2b-unit-price-val');
      if (unitPriceVal) {
        unitPriceVal.innerHTML = formatMoney(activePrice);
      }

      // Calculate and display savings
      const retailCost = retailPrice * qty;
      const wholesaleCost = activePrice * qty;
      const totalSavings = retailCost - wholesaleCost;

      const savingsBox = document.querySelector('.b2b-savings-box');
      const savingsVal = document.querySelector('.b2b-savings-amount');
      if (savingsBox && savingsVal) {
        if (totalSavings > 0) {
          savingsVal.innerHTML = formatMoney(totalSavings);
          savingsBox.style.display = 'flex';
        } else {
          savingsBox.style.display = 'none';
        }
      }

      // Show alert if below MOQ
      const warningEl = document.querySelector('.b2b-moq-warning');
      if (warningEl) {
        if (qty < moq) {
          warningEl.classList.add('active');
          if (addToCartBtn) addToCartBtn.disabled = true;
          if (addToCartText) addToCartText.innerText = `Min. Order is ${moq} Units`;
        } else {
          warningEl.classList.remove('active');
          if (addToCartBtn) addToCartBtn.disabled = false;
          if (addToCartText) addToCartText.innerText = 'Add to Cart';
        }
      }
    }

    function validateProductFormSubmit(e) {
      const mode = getActiveMode();
      if (mode !== MODE_BUSINESS) return;

      const qty = parseInt(qtyInput.value, 10) || 1;
      if (qty < moq) {
        e.preventDefault();
        e.stopPropagation();
        alert(`Minimum order quantity for wholesale purchasing is ${moq} units.`);
        qtyInput.value = moq;
        updateProductPricingSummary();
        return false;
      }
    }
  }

  // ----------------------------------------
  // Cart Page Validations & MOQ Checks
  // ----------------------------------------
  function setupCartPageIntegrations(mode) {
    const cartForm = document.querySelector('form.cart');
    if (!cartForm) return;

    const checkoutBtn = cartForm.querySelector('[name="checkout"]');
    const cartRows = cartForm.querySelectorAll('tr.cart__row');
    let hasValidationError = false;
    let totalRetailVal = 0;
    let totalWholesaleVal = 0;

    cartRows.forEach(row => {
      const qtyInput = row.querySelector('.cart__quantity');
      if (!qtyInput) return;

      const qty = parseInt(qtyInput.value, 10) || 0;
      const moq = parseInt(row.dataset.moq || '1', 10);
      const retailPrice = parseFloat(row.dataset.price || '0');
      const wholesalePrice = parseFloat(row.dataset.wholesalePrice || (retailPrice * 0.75));

      // Calculate totals
      totalRetailVal += retailPrice * qty;
      totalWholesaleVal += wholesalePrice * qty;

      // Handle B2B validation error indicators
      let errorIndicator = row.querySelector('.b2b-item-moq-error');
      if (!errorIndicator) {
        errorIndicator = document.createElement('div');
        errorIndicator.className = 'b2b-item-moq-error';
        const titleCell = row.cells[1] || row.querySelector('.cart__cell--image');
        if (titleCell) {
          titleCell.appendChild(errorIndicator);
        }
      }

      if (mode === MODE_BUSINESS && qty < moq && qty > 0) {
        errorIndicator.innerText = `⚠️ Wholesale MOQ is ${moq} units. Current: ${qty}.`;
        errorIndicator.style.display = 'block';
        row.style.background = 'rgba(220, 53, 69, 0.02)';
        hasValidationError = true;
      } else {
        errorIndicator.style.display = 'none';
        row.style.background = '';
      }
    });

    // Handle checkout button locking
    if (checkoutBtn) {
      if (mode === MODE_BUSINESS && hasValidationError) {
        checkoutBtn.disabled = true;
        checkoutBtn.title = 'Please satisfy Minimum Order Quantity requirements before checkout.';
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.cursor = 'not-allowed';
      } else {
        checkoutBtn.disabled = false;
        checkoutBtn.title = '';
        checkoutBtn.style.opacity = '';
        checkoutBtn.style.cursor = '';
      }
    }

    // Render Savings Summary in Cart
    const totalSavings = totalRetailVal - totalWholesaleVal;
    const savingsSummaryEl = document.querySelector('.b2b-cart-savings-summary');
    if (savingsSummaryEl) {
      if (mode === MODE_BUSINESS && totalSavings > 0) {
        const amtEl = savingsSummaryEl.querySelector('.b2b-savings-amt');
        if (amtEl) amtEl.innerHTML = formatMoney(totalSavings);
        savingsSummaryEl.style.display = 'flex';
      } else {
        savingsSummaryEl.style.display = 'none';
      }
    }

    // Update Currency Conversion Notice in Cart (User Request)
    const convertedDisplay = document.getElementById('ConvertedCartTotalDisplay');
    const baseDisplay = document.getElementById('BaseCartTotalDisplay');
    const isoDisplay = document.getElementById('RegionCurrencyIso');
    const symbolDisplay = document.getElementById('RegionCurrencySymbol');

    if (convertedDisplay && baseDisplay) {
      const activeIso = (isoDisplay ? isoDisplay.innerText.trim() : 'USD') || 'USD';
      
      const rates = {
        'INR': { rate: 1.0, symbol: '₹' },
        'USD': { rate: 0.01205, symbol: '$' },
        'EUR': { rate: 0.01107, symbol: '€' },
        'GBP': { rate: 0.00948, symbol: '£' },
        'CAD': { rate: 0.01642, symbol: 'CA$' },
        'AUD': { rate: 0.01792, symbol: 'AU$' },
        'AED': { rate: 0.04426, symbol: 'AED' },
        'SGD': { rate: 0.01618, symbol: 'SG$' },
        'JPY': { rate: 1.875, symbol: '¥' },
        'CHF': { rate: 0.01072, symbol: 'CHF' },
        'NZD': { rate: 0.01970, symbol: 'NZ$' },
        'ZAR': { rate: 0.2205, symbol: 'R' },
        'BRL': { rate: 0.0673, symbol: 'R$' },
        'MXN': { rate: 0.2135, symbol: 'MX$' },
        'SAR': { rate: 0.04518, symbol: 'SAR' },
        'SEK': { rate: 0.1265, symbol: 'kr' },
        'NOK': { rate: 0.1298, symbol: 'kr' },
        'DKK': { rate: 0.0826, symbol: 'kr' },
        'MYR': { rate: 0.0567, symbol: 'RM' },
        'KRW': { rate: 16.75, symbol: '₩' },
        'PHP': { rate: 0.702, symbol: '₱' },
        'THB': { rate: 0.435, symbol: '฿' },
        'VND': { rate: 305.5, symbol: '₫' }
      };

      const rateObj = rates[activeIso] || { rate: 0.01205, symbol: '$' };
      
      let inrBaseCents = (mode === MODE_BUSINESS) ? totalWholesaleVal : totalRetailVal;
      if (!inrBaseCents || inrBaseCents === 0) {
        const subtotalEl = document.getElementById('CartSubtotal');
        if (subtotalEl) {
          const rawNum = parseFloat(subtotalEl.innerText.replace(/[^0-9.]/g, ''));
          if (!isNaN(rawNum)) inrBaseCents = rawNum * 100;
        }
      }
      
      const inrBaseVal = inrBaseCents / 100;
      const convertedVal = (inrBaseVal * rateObj.rate).toFixed(2);

      convertedDisplay.innerText = convertedVal;
      baseDisplay.innerText = inrBaseVal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (symbolDisplay) symbolDisplay.innerText = rateObj.symbol;
    }
  }

  // ----------------------------------------
  // Dynamic Storefront Multi-Currency Converter Engine (Full 208-Region Rates)
  // ----------------------------------------
  const CURRENCY_RATES = {
    'INR': { rate: 1.0, symbol: 'Rs.', name: 'India' },
    'USD': { rate: 0.01193, symbol: '$', name: 'United States' },
    'EUR': { rate: 0.01107, symbol: '€', name: 'Eurozone' },
    'GBP': { rate: 0.00938, symbol: '£', name: 'United Kingdom' },
    'CAD': { rate: 0.01633, symbol: 'CA$', name: 'Canada' },
    'AUD': { rate: 0.01792, symbol: 'A$', name: 'Australia' },
    'AED': { rate: 0.04381, symbol: 'AED', name: 'United Arab Emirates' },
    'AFN': { rate: 0.817, symbol: 'Af', name: 'Afghanistan' },
    'ALL': { rate: 1.096, symbol: 'Lek', name: 'Albania' },
    'DZD': { rate: 1.597, symbol: 'DA', name: 'Algeria' },
    'AOA': { rate: 11.02, symbol: 'Kz', name: 'Angola' },
    'XCD': { rate: 0.0322, symbol: 'EC$', name: 'East Caribbean' },
    'ARS': { rate: 12.24, symbol: '$', name: 'Argentina' },
    'AMD': { rate: 4.62, symbol: '֏', name: 'Armenia' },
    'AWG': { rate: 0.0214, symbol: 'Afl.', name: 'Aruba' },
    'SHP': { rate: 0.00938, symbol: '£', name: 'Saint Helena' },
    'AZN': { rate: 0.0202, symbol: '₼', name: 'Azerbaijan' },
    'BSD': { rate: 0.0119, symbol: 'B$', name: 'Bahamas' },
    'BHD': { rate: 0.00449, symbol: 'BD', name: 'Bahrain' },
    'BDT': { rate: 1.417, symbol: '৳', name: 'Bangladesh' },
    'BBD': { rate: 0.0238, symbol: 'Bds$', name: 'Barbados' },
    'BYN': { rate: 0.0389, symbol: 'Br', name: 'Belarus' },
    'BZD': { rate: 0.0238, symbol: 'BZ$', name: 'Belize' },
    'XOF': { rate: 7.26, symbol: 'CFA', name: 'West Africa' },
    'BMD': { rate: 0.0119, symbol: 'BD$', name: 'Bermuda' },
    'BTN': { rate: 1.0, symbol: 'Nu.', name: 'Bhutan' },
    'BOB': { rate: 0.0825, symbol: 'Bs.', name: 'Bolivia' },
    'BAM': { rate: 0.0216, symbol: 'KM', name: 'Bosnia' },
    'BWP': { rate: 0.162, symbol: 'P', name: 'Botswana' },
    'BRL': { rate: 0.0665, symbol: 'R$', name: 'Brazil' },
    'BND': { rate: 0.0160, symbol: 'B$', name: 'Brunei' },
    'BGN': { rate: 0.0216, symbol: 'лв', name: 'Bulgaria' },
    'BIF': { rate: 34.2, symbol: 'FBu', name: 'Burundi' },
    'KHR': { rate: 48.7, symbol: '៛', name: 'Cambodia' },
    'XAF': { rate: 7.26, symbol: 'FCFA', name: 'Central Africa' },
    'CVE': { rate: 1.22, symbol: 'Esc', name: 'Cape Verde' },
    'KYD': { rate: 0.0099, symbol: 'CI$', name: 'Cayman Islands' },
    'CLP': { rate: 11.25, symbol: 'CLP$', name: 'Chile' },
    'CNY': { rate: 0.0862, symbol: '¥', name: 'China' },
    'COP': { rate: 48.9, symbol: 'COL$', name: 'Colombia' },
    'KMF': { rate: 5.44, symbol: 'CF', name: 'Comoros' },
    'CDF': { rate: 33.8, symbol: 'FC', name: 'Congo' },
    'NZD': { rate: 0.0197, symbol: 'NZ$', name: 'New Zealand' },
    'CRC': { rate: 6.18, symbol: '₡', name: 'Costa Rica' },
    'HRK': { rate: 0.0834, symbol: 'kn', name: 'Croatia' },
    'ANG': { rate: 0.0214, symbol: 'NAƒ', name: 'Curaçao' },
    'CZK': { rate: 0.278, symbol: 'Kč', name: 'Czechia' },
    'DKK': { rate: 0.0826, symbol: 'kr', name: 'Denmark' },
    'DJF': { rate: 2.12, symbol: 'Fdj', name: 'Djibouti' },
    'DOP': { rate: 0.715, symbol: 'RD$', name: 'Dominican Republic' },
    'EGP': { rate: 0.582, symbol: 'E£', name: 'Egypt' },
    'SVC': { rate: 0.104, symbol: '₡', name: 'El Salvador' },
    'ERN': { rate: 0.179, symbol: 'Nfk', name: 'Eritrea' },
    'SZL': { rate: 0.218, symbol: 'E', name: 'Eswatini' },
    'ETB': { rate: 1.48, symbol: 'Br', name: 'Ethiopia' },
    'FKP': { rate: 0.00938, symbol: 'FK£', name: 'Falkland Islands' },
    'FJD': { rate: 0.0268, symbol: 'FJ$', name: 'Fiji' },
    'GMD': { rate: 0.812, symbol: 'D', name: 'Gambia' },
    'GEL': { rate: 0.0322, symbol: '₾', name: 'Georgia' },
    'GHS': { rate: 0.185, symbol: 'GH₵', name: 'Ghana' },
    'GIP': { rate: 0.00938, symbol: 'GIP£', name: 'Gibraltar' },
    'GTQ': { rate: 0.0921, symbol: 'Q', name: 'Guatemala' },
    'GNF': { rate: 102.5, symbol: 'FG', name: 'Guinea' },
    'GYD': { rate: 2.49, symbol: 'GY$', name: 'Guyana' },
    'HTG': { rate: 1.57, symbol: 'G', name: 'Haiti' },
    'HNL': { rate: 0.294, symbol: 'L', name: 'Honduras' },
    'HKD': { rate: 0.0931, symbol: 'HK$', name: 'Hong Kong' },
    'HUF': { rate: 4.38, symbol: 'Ft', name: 'Hungary' },
    'ISK': { rate: 1.64, symbol: 'kr', name: 'Iceland' },
    'IDR': { rate: 189.5, symbol: 'Rp', name: 'Indonesia' },
    'IQD': { rate: 15.62, symbol: 'IQD', name: 'Iraq' },
    'ILS': { rate: 0.0435, symbol: '₪', name: 'Israel' },
    'JMD': { rate: 1.87, symbol: 'J$', name: 'Jamaica' },
    'JPY': { rate: 1.83, symbol: '¥', name: 'Japan' },
    'JOD': { rate: 0.00845, symbol: 'JD', name: 'Jordan' },
    'KZT': { rate: 5.86, symbol: '₸', name: 'Kazakhstan' },
    'KES': { rate: 1.53, symbol: 'KSh', name: 'Kenya' },
    'KWD': { rate: 0.00366, symbol: 'KD', name: 'Kuwait' },
    'KGS': { rate: 1.04, symbol: 'сом', name: 'Kyrgyzstan' },
    'LAK': { rate: 258.5, symbol: '₭', name: 'Laos' },
    'LBP': { rate: 1068.0, symbol: 'L£', name: 'Lebanon' },
    'LSL': { rate: 0.218, symbol: 'L', name: 'Lesotho' },
    'LRD': { rate: 2.29, symbol: 'L$', name: 'Liberia' },
    'LYD': { rate: 0.0578, symbol: 'LD', name: 'Libya' },
    'MOP': { rate: 0.0959, symbol: 'MOP$', name: 'Macau' },
    'MKD': { rate: 0.681, symbol: 'ден', name: 'North Macedonia' },
    'MGA': { rate: 54.2, symbol: 'Ar', name: 'Madagascar' },
    'MWK': { rate: 20.6, symbol: 'MK', name: 'Malawi' },
    'MYR': { rate: 0.0518, symbol: 'RM', name: 'Malaysia' },
    'MVR': { rate: 0.184, symbol: 'Rf', name: 'Maldives' },
    'MRU': { rate: 0.472, symbol: 'UM', name: 'Mauritania' },
    'MUR': { rate: 0.552, symbol: 'Rs', name: 'Mauritius' },
    'MXN': { rate: 0.218, symbol: 'Mex$', name: 'Mexico' },
    'MDL': { rate: 0.211, symbol: 'L', name: 'Moldova' },
    'MNT': { rate: 41.5, symbol: '₮', name: 'Mongolia' },
    'MAD': { rate: 0.118, symbol: 'DH', name: 'Morocco' },
    'MZN': { rate: 0.761, symbol: 'MT', name: 'Mozambique' },
    'MMK': { rate: 25.1, symbol: 'Ks', name: 'Myanmar' },
    'NAD': { rate: 0.218, symbol: 'N$', name: 'Namibia' },
    'NPR': { rate: 1.60, symbol: 'Rs', name: 'Nepal' },
    'NIO': { rate: 0.438, symbol: 'C$', name: 'Nicaragua' },
    'NGN': { rate: 18.25, symbol: '₦', name: 'Nigeria' },
    'OMR': { rate: 0.00459, symbol: 'OMR', name: 'Oman' },
    'PKR': { rate: 3.32, symbol: 'Rs', name: 'Pakistan' },
    'PAB': { rate: 0.0119, symbol: 'B/.', name: 'Panama' },
    'PGK': { rate: 0.0462, symbol: 'K', name: 'Papua New Guinea' },
    'PYG': { rate: 91.2, symbol: '₲', name: 'Paraguay' },
    'PEN': { rate: 0.0442, symbol: 'S/.', name: 'Peru' },
    'PHP': { rate: 0.685, symbol: '₱', name: 'Philippines' },
    'PLN': { rate: 0.0475, symbol: 'zł', name: 'Poland' },
    'QAR': { rate: 0.0434, symbol: 'QR', name: 'Qatar' },
    'RON': { rate: 0.0551, symbol: 'lei', name: 'Romania' },
    'RUB': { rate: 1.06, symbol: '₽', name: 'Russia' },
    'RWF': { rate: 16.2, symbol: 'FRw', name: 'Rwanda' },
    'WST': { rate: 0.0325, symbol: 'WS$', name: 'Samoa' },
    'STN': { rate: 0.271, symbol: 'Db', name: 'São Tomé' },
    'SAR': { rate: 0.0447, symbol: 'SR', name: 'Saudi Arabia' },
    'RSD': { rate: 1.29, symbol: 'din', name: 'Serbia' },
    'SCR': { rate: 0.165, symbol: 'SR', name: 'Seychelles' },
    'SLL': { rate: 268.0, symbol: 'Le', name: 'Sierra Leone' },
    'SGD': { rate: 0.0160, symbol: 'S$', name: 'Singapore' },
    'SBD': { rate: 0.101, symbol: 'SI$', name: 'Solomon Islands' },
    'SOS': { rate: 6.81, symbol: 'Sh.So.', name: 'Somalia' },
    'ZAR': { rate: 0.218, symbol: 'R', name: 'South Africa' },
    'SSP': { rate: 15.5, symbol: 'SS£', name: 'South Sudan' },
    'LKR': { rate: 3.65, symbol: 'Rs', name: 'Sri Lanka' },
    'SDG': { rate: 7.15, symbol: 'SDG', name: 'Sudan' },
    'SRD': { rate: 0.428, symbol: 'Sr$', name: 'Suriname' },
    'SEK': { rate: 0.126, symbol: 'kr', name: 'Sweden' },
    'CHF': { rate: 0.0105, symbol: 'CHF', name: 'Switzerland' },
    'TWD': { rate: 0.386, symbol: 'NT$', name: 'Taiwan' },
    'TJS': { rate: 0.127, symbol: 'TJS', name: 'Tajikistan' },
    'TZS': { rate: 31.8, symbol: 'TSh', name: 'Tanzania' },
    'THB': { rate: 0.428, symbol: '฿', name: 'Thailand' },
    'TOP': { rate: 0.0281, symbol: 'T$', name: 'Tonga' },
    'TTD': { rate: 0.0809, symbol: 'TT$', name: 'Trinidad & Tobago' },
    'TND': { rate: 0.0371, symbol: 'DT', name: 'Tunisia' },
    'TRY': { rate: 0.392, symbol: '₺', name: 'Turkey' },
    'TMT': { rate: 0.0418, symbol: 'm', name: 'Turkmenistan' },
    'UGX': { rate: 43.8, symbol: 'USh', name: 'Uganda' },
    'UAH': { rate: 0.491, symbol: '₴', name: 'Ukraine' },
    'AED': { rate: 0.0438, symbol: 'AED', name: 'UAE' },
    'UYU': { rate: 0.482, symbol: '$U', name: 'Uruguay' },
    'UZS': { rate: 151.2, symbol: 'soʻm', name: 'Uzbekistan' },
    'VUV': { rate: 1.42, symbol: 'VT', name: 'Vanuatu' },
    'VES': { rate: 0.435, symbol: 'Bs.S', name: 'Venezuela' },
    'VND': { rate: 302.5, symbol: '₫', name: 'Vietnam' },
    'XPF': { rate: 1.32, symbol: 'F', name: 'Wallis & Futuna' },
    'YER': { rate: 2.98, symbol: 'YR', name: 'Yemen' },
    'ZMW': { rate: 0.315, symbol: 'ZK', name: 'Zambia' },
    'ZWL': { rate: 3.84, symbol: 'Z$', name: 'Zimbabwe' }
  };

  function getActiveCurrency() {
    return localStorage.getItem('rudrayati_user_currency') || 'INR';
  }

  function setupDynamicCurrencyConverter() {
    // Support multiple region selectors (e.g. header on desktop + hamburger drawer on mobile).
    const nativeSelects = document.querySelectorAll('.b2b-region-native-select');
    const displayLabels = document.querySelectorAll('.b2b-region-selected-text');

    const activeCurrencyCode = getActiveCurrency();
    const activeData = CURRENCY_RATES[activeCurrencyCode] || { rate: 1.0, symbol: 'RS', name: 'India' };

    function selectByCurrency(sel, currency) {
      for (let i = 0; i < sel.options.length; i++) {
        if (sel.options[i].dataset.currency === currency) { sel.selectedIndex = i; break; }
      }
    }

    function syncAll(currency, symbol, name) {
      nativeSelects.forEach(function(sel) { selectByCurrency(sel, currency); });
      displayLabels.forEach(function(lbl) { lbl.innerText = `${name} (${currency} ${symbol})`; });
    }

    nativeSelects.forEach(function(nativeSelect) {
      selectByCurrency(nativeSelect, activeCurrencyCode);

      nativeSelect.addEventListener('change', function() {
        const selectedOpt = nativeSelect.options[nativeSelect.selectedIndex];
        const newCurrency = selectedOpt.dataset.currency || 'INR';
        const newSymbol = selectedOpt.dataset.symbol || 'RS';
        const newName = selectedOpt.dataset.name || 'India';

        localStorage.setItem('rudrayati_user_currency', newCurrency);
        localStorage.setItem('rudrayati_user_symbol', newSymbol);
        localStorage.setItem('rudrayati_user_country_name', newName);

        syncAll(newCurrency, newSymbol, newName);
        convertAllStorefrontPrices(newCurrency, newSymbol);
      });
    });

    if (displayLabels.length) {
      const savedName = localStorage.getItem('rudrayati_user_country_name') || activeData.name;
      const savedSymbol = localStorage.getItem('rudrayati_user_symbol') || activeData.symbol;
      displayLabels.forEach(function(lbl) {
        lbl.innerText = `${savedName} (${activeCurrencyCode} ${savedSymbol})`;
      });
    }

    convertAllStorefrontPrices(activeCurrencyCode, localStorage.getItem('rudrayati_user_symbol') || activeData.symbol);
  }

  function convertAllStorefrontPrices(currencyCode, optSymbol) {
    const activeCode = currencyCode || getActiveCurrency();
    const rateData = CURRENCY_RATES[activeCode] || { rate: 1.0, symbol: 'RS', name: 'India' };
    const symbol = optSymbol || rateData.symbol || 'RS';

    // 1. Tag product card containers with real base INR price
    document.querySelectorAll('.product-card, [data-price]').forEach(card => {
      if (!card.dataset.baseInr && card.dataset.price) {
        const p = parseFloat(card.dataset.price);
        if (!isNaN(p) && p > 0) {
          // If Shopify passed price in cents e.g. 77900 or 59900
          card.dataset.baseInr = p > 1000 ? (p / 100.0) : p;
        }
      }
    });

    // 2. Select target price nodes ONLY (leaf elements + strike-through compare prices)
    const priceElements = document.querySelectorAll(
      '.price-item, .product-card__price, .cart__item-total, #CartSubtotal, .b2b-unit-price-val, .b2b-savings-amount, #ProductPrice-product-template-1, [id*="ComparePrice"], .product-single__price, .product-single__price--compare, s.product-single__price, s, strike, del'
    );

    priceElements.forEach(el => {
      if (el.closest('.b2b-cart-currency-notice') || el.closest('#b2b-bundler-slot')) return;

      const txt = el.innerText.trim();
      if (!txt) return;

      // Extract base INR value safely
      if (txt.includes('Rs.') || txt.includes('INR') || txt.includes('₹') || !el.dataset.baseInr || isNaN(parseFloat(el.dataset.baseInr))) {
        const cleanTxt = txt.replace(/[^0-9.]/g, '');
        const baseVal = parseFloat(cleanTxt);
        if (!isNaN(baseVal) && baseVal >= 1) {
          el.dataset.baseInr = baseVal;
        } else {
          const parentCard = el.closest('[data-base-inr]');
          if (parentCard && parentCard.dataset.baseInr) {
            el.dataset.baseInr = parentCard.dataset.baseInr;
          }
        }
      }

      if (el.dataset.baseInr) {
        const baseInr = parseFloat(el.dataset.baseInr);
        if (isNaN(baseInr) || baseInr <= 0) return;

        const converted = (baseInr * rateData.rate).toFixed(2);
        const formattedNum = parseFloat(converted).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        
        let targetText = '';
        if (activeCode === 'INR') {
          targetText = `Rs. ${baseInr.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        } else {
          targetText = `${symbol} ${formattedNum}`;
        }

        if (el.innerText !== targetText) {
          el.innerText = targetText;
        }
      }
    });

    // 3. Dynamically convert ONLY actual price elements inside Bundler App widget
    (function convertBundlerAppPrices() {
      const bundlerSlot = document.getElementById('b2b-bundler-slot') || document.querySelector('.bundler-target-element, .bk-summary, [data-bundler-container], .bundler-container, .bundler-app');
      if (!bundlerSlot) return;

      const allElements = bundlerSlot.querySelectorAll('*');

      allElements.forEach(function(el) {
        if (el.children.length === 0 && el.innerText) {
          const text = el.innerText.trim();
          if (!text) return;

          // SKIP quantity labels (e.g. "Buy 10 and get a discount!") & discount buttons (e.g. "Save 5%!")
          if (/(?:buy\s+\d+|save\s+\d+|%|discount)/i.test(text)) {
            return;
          }

          // 1. Extract base INR price if not already cached (MUST contain currency indicator or clean money number)
          if (!el.dataset.baseInr) {
            if (/(?:Rs\.?|INR|₹)/i.test(text) || el.classList.contains('bk-price') || el.tagName === 'S' || el.tagName === 'STRIKE') {
              const match = text.match(/([\d,]+(?:\.\d+)?)/);
              if (match && match[1]) {
                const baseVal = parseFloat(match[1].replace(/,/g, ''));
                if (!isNaN(baseVal) && baseVal >= 1) {
                  el.dataset.baseInr = baseVal;
                }
              }
            }
          }

          // 2. Convert from el.dataset.baseInr directly to current active currency!
          if (el.dataset.baseInr) {
            const baseInr = parseFloat(el.dataset.baseInr);
            if (isNaN(baseInr) || baseInr <= 0) return;

            let formattedPrice = '';
            if (activeCode === 'INR') {
              formattedPrice = `Rs. ${baseInr.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            } else {
              const converted = (baseInr * rateData.rate).toFixed(2);
              const formattedNum = parseFloat(converted).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              formattedPrice = `${symbol} ${formattedNum}`;
            }

            if (el.innerText !== formattedPrice) {
              el.innerText = formattedPrice;
            }
          }
        }
      });
    })();

    // Update all Cart Currency Notice cards (Cart Page + Slideout Cart Drawer)
    function refreshLiveCartNotice() {
      const noticeCards = document.querySelectorAll('.b2b-cart-currency-notice');
      if (noticeCards.length === 0) return;

      fetch('/cart.js?t=' + Date.now())
        .then(res => res.json())
        .then(cart => {
          if (cart && typeof cart.total_price === 'number') {
            const liveInr = cart.total_price / 100.0;
            const convVal = (liveInr * rateData.rate).toFixed(2);
            const formattedConv = parseFloat(convVal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            const formattedBase = liveInr.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            noticeCards.forEach(noticeEl => {
              const isoEls = noticeEl.querySelectorAll('.b2b-notice-iso, #RegionCurrencyIso');
              const symbolEls = noticeEl.querySelectorAll('.b2b-notice-symbol, #RegionCurrencySymbol');
              const convEls = noticeEl.querySelectorAll('.b2b-notice-converted, #ConvertedCartTotalDisplay');
              const baseEls = noticeEl.querySelectorAll('.b2b-notice-base, #BaseCartTotalDisplay');

              isoEls.forEach(el => el.innerText = activeCode);
              symbolEls.forEach(el => el.innerText = symbol);
              convEls.forEach(el => el.innerText = formattedConv);
              baseEls.forEach(el => el.innerText = formattedBase);
            });
          }
        })
        .catch(function() {});
    }

    refreshLiveCartNotice();
  }

  // Helper to format currency values
  function formatMoney(cents) {
    let val = cents;
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(val);
    }
    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    if (val > 10000000) {
      val = val / 100;
    } else if (val > 0 && String(val).indexOf('.') === -1 && val % 100 === 0) {
      val = val / 100;
    } else if (val > 100 && String(val).indexOf('.') === -1) {
       val = val / 100;
    }
    return formatter.format(val);
  }

  // Forcefully remove any currency converter popup / widget from DOM
  function removeCurrencySwitcherWidgets() {
    const selectors = [
      'localization-form',
      '.localization-form',
      '.localization-selector',
      '.disclosure',
      '#FooterCountryForm',
      '#HeaderCountryForm',
      '#HeaderCountryFormMobile',
      '.country-flag',
      '.shopify-localization-form',
      '.doubly-wrapper',
      '#doubly-currencies',
      '.currency-switcher',
      '.currency-picker',
      '.currency-selector',
      '.transcy-switcher',
      '.transcy-wrapper',
      '#shopify-user-location',
      '#hextom_curr_switcher',
      '.avada-m-picker',
      '[class*="avada-currency"]',
      '[id*="avada-currency"]',
      '[class*="mleda-currency"]',
      '[id*="mleda-currency"]',
      '[id*="CountryForm"]',
      '[id*="CountryList"]',
      '#shopify-section-geolocation',
      '.shopify-geolocation-popup'
    ];

    selectors.forEach(function(sel) {
      try {
        document.querySelectorAll(sel).forEach(function(el) {
          if (el.closest('.b2b-region-selector-wrapper')) return;
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('opacity', '0', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          if (el.parentNode && el.tagName !== 'BODY' && el.tagName !== 'HTML') {
            el.remove();
          }
        });
      } catch(e) {}
    });

    // Content-based purge for dynamic app widgets (e.g. matching "Auto Location" or currency lists)
    try {
      const candidates = document.querySelectorAll('div, section, iframe, shopify-user-location, ul, span');
      candidates.forEach(function(el) {
        if (!el || !el.innerText) return;
        const txt = el.innerText.trim();
        if (
          txt.indexOf('Auto Location') !== -1 ||
          (txt.indexOf('US Dollar') !== -1 && txt.indexOf('Canadian Dollar') !== -1) ||
          (txt.indexOf('British Pound') !== -1 && txt.indexOf('INR') !== -1) ||
          (txt.indexOf('Euro (EUR)') !== -1 && txt.indexOf('Auto Location') !== -1)
        ) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('opacity', '0', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          if (el.parentNode && el.tagName !== 'BODY' && el.tagName !== 'HTML') {
            el.remove();
          }
        }
      });
    } catch(e) {}
  }

  // Active Purge & Cart Observer Triggers
  removeCurrencySwitcherWidgets();
  if (window.MutationObserver && document.documentElement) {
    var currencyObserver = new MutationObserver(function() {
      removeCurrencySwitcherWidgets();
    });
    currencyObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
  setInterval(removeCurrencySwitcherWidgets, 400);

  // Global listeners for live cart drawer changes
  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-toggle-cart, .cardraw, .js-mini-cart, .js-qty__adjust, .cart__quantity, .js-btn-quickview, [name="add"]')) {
      setTimeout(function() {
        if (typeof convertAllStorefrontPrices === 'function') {
          convertAllStorefrontPrices();
        }
      }, 300);
      setTimeout(function() {
        if (typeof convertAllStorefrontPrices === 'function') {
          convertAllStorefrontPrices();
        }
      }, 800);
    }
  });

  // Observe cart total updates dynamically
  if (window.MutationObserver) {
    var cartObserver = new MutationObserver(function() {
      if (typeof convertAllStorefrontPrices === 'function') {
        convertAllStorefrontPrices();
      }
    });
    setTimeout(function() {
      var cartTotalEl = document.querySelector('.js-cart-total') || document.getElementById('CartSubtotal') || document.querySelector('.mini-cart-content');
      if (cartTotalEl) {
        cartObserver.observe(cartTotalEl, { childList: true, characterData: true, subtree: true });
      }
    }, 1000);
  }

  // DOMContentLoaded & Loaders (safety first)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function() {
    setupDynamicCurrencyConverter();
    if (typeof convertAllStorefrontPrices === 'function') {
      convertAllStorefrontPrices();
    }
  });

  // Periodic safety sweep to convert dynamically loaded products/collection filters
  setInterval(function() {
    if (typeof convertAllStorefrontPrices === 'function') {
      convertAllStorefrontPrices();
    }
  }, 1500);

  // Export globally
  window.B2BCore = {
    getActiveMode: getActiveMode,
    switchMode: switchMode,
    openModal: openExperienceModal,
    closeModal: closeExperienceModal,
    convertPrices: convertAllStorefrontPrices
  };

})();

